import React from "react";
import LandingPage from "./components/LandingPage";
import LoginPage from "./components/UserIdentification/LoginPage";
import RegisterPage from "./components/UserIdentification/RegisterPage";
import MainController from "./components/AppMain/MainController";
import NewMainController from "./components/AppMain/NewMainController";
import GuestRoute from "./components/routes/GuestRoute";
import UserRoute from "./components/routes/UserRoute";

const App = () => {
  return(
    <div>
      <GuestRoute path="/" exact component={LandingPage}/>
      <GuestRoute path="/signin" exact component={LoginPage}/>
      <GuestRoute path="/register" exact component={RegisterPage}/>
      <UserRoute path="/dashboard" exact component={MainController}/>
      <UserRoute path="/main" component={NewMainController}/>
    </div>
  );
};

export default App;